export default __webpack_public_path__ + "static/media/servicespare.242cfbaa.png";